import React, { createContext, useContext, useState, useCallback } from 'react';

// Context to manage global data refresh
const RefreshContext = createContext();

// Hook for components to access the refresh functionality
export const useRefresh = () => useContext(RefreshContext);

export const RefreshProvider = ({ children }) => {
  // Counter to trigger refreshes - components can subscribe to changes in this value
  const [refreshCounter, setRefreshCounter] = useState(0);
  
  // Timestamp of the last refresh - useful for UI indicators
  const [lastRefreshTime, setLastRefreshTime] = useState(null);
  
  // Flag to indicate a refresh is in progress
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  // Function to trigger a global data refresh
  const refreshData = useCallback(() => {
    setIsRefreshing(true);
    // Increment counter to trigger all subscribed components to refresh
    setRefreshCounter(prevCounter => prevCounter + 1);
    setLastRefreshTime(new Date());
    
    // Reset the refreshing flag after a short delay to allow components to update
    setTimeout(() => {
      setIsRefreshing(false);
    }, 1000);
  }, []);
  
  // Value to be provided to consuming components
  const value = {
    refreshCounter,
    lastRefreshTime,
    isRefreshing,
    refreshData
  };
  
  return (
    <RefreshContext.Provider value={value}>
      {children}
    </RefreshContext.Provider>
  );
};

export default RefreshProvider;
